import { useState } from "react"
import styled from "styled-components"

import { IconButton, Popover, Text } from "@minuthq/meatball-ui-react"

import { CopyClientSecret } from "src/components/ApiClients/ApiClientsTable"
import ExpandDownIcon from "src/ui/icons/expand-down.svg"
import { MCard } from "src/ui/MCard/MCard"
import { spacing } from "src/ui/spacing"

export function ParadiseUserApiClientSecret({
  clientId,
}: {
  clientId: string
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  return (
    <div>
      <TextBox>
        <Text variant="body">••••••••••••••</Text>

        <Popover
          trigger={
            <IconButton
              onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}
              size="small"
              variant="minimal"
              Icon={ExpandDownIcon}
            />
          }
        >
          <MCard padding={0}>
            <CopyClientSecret clientId={clientId} />
          </MCard>
        </Popover>
      </TextBox>
    </div>
  )
}

const TextBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.XS2};
`
